import { Button, Grid, SxProps, Theme, Typography } from '@mui/material';
import { useQuoteState } from 'shared/contexts';
import { CustomProductDetails } from './custom-product-details';

interface ICustomProductContainerProps {
  styles: SxProps<Theme>;
}

export function CustomProductContainer({ styles }: ICustomProductContainerProps) {
  const { editMode, setTempCustomProduct, toggleNewCustomProductDialog } = useQuoteState();

  return (
    <Grid sx={styles}>
      <Grid container direction='row' justifyContent='space-between'>
        <Typography variant='h5'>Custom Product Details</Typography>
        {editMode && (
          <Grid item>
            <Button
              color='secondary'
              variant='outlined'
              onClick={() => {
                setTempCustomProduct(null);
                toggleNewCustomProductDialog();
              }}
            >
              Add Custom Product
            </Button>
          </Grid>
        )}
      </Grid>
      <CustomProductDetails />
    </Grid>
  );
}
